import './styles/production';
import './images/production-item-1.jpg';
import './images/production-item-2.jpg';
import './images/production-bg.jpg';
import './images/production-nmarksbg.jpg';
import './images/production-omcarbbg.jpg';
import './images/production-masonry-bg.jpg';
import './images/use-bg-1-ru.jpg';
import './images/use-bg-1-en.jpg';
import './images/use-bg-2-ru.jpg';
import './images/use-bg-2-en.jpg';

import Barba from 'barba.js';
import $ from 'jquery';
import { $html, $htmlBody, isFirst } from './common'



function productionOn() {
    if ($('.production-carbon__slide').length) {
        addWidthCarbon();
    }
    $('a[href*="#"]:not([href="#"])').on('click', function() {
        let target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.substr(1) + ']');
        if (target.length) {
            $htmlBody.animate({
                scrollTop: target.offset().top
            }, 1000);
            return false;
        }
    });

    function addWidthCarbon() {
        let result = 0;
        $('.production-carbon__slide').each(function(i, item) {
            let width = $(item).width();
            if (width > result) {
                result = width;
                $(this).parent().css('width', result);
            }
        });
    }

    $(window).on('resize', addWidthCarbon);

    function animateCarbon(direction) {
        let $items = $('.production-carbon__slide');
        let $active = $('.production-carbon__slide.is-active');
        let l = $items.length - 1;
        let index = $items.index($active);

        if (direction === 'next') {
            if (index >= l) index = 0;
            else index++;
        } else if (direction === 'prev') {
            if (!index) index = l;
            else index--;
        }

        $active.removeClass('is-active');
        $($items[index]).addClass('is-active');
    }

    $('.mark__head').on('click', function(e) {
        let $target = $(e.target);
        let $mark = $(this).parent();
        const ACTIVE = 'is-active';

        if (!$target.hasClass('mark__text_docs')) {
            if (!$mark.hasClass(ACTIVE) && $mark.children('.mark__more').length) {
                $mark.addClass(ACTIVE);
            } else {
                $mark.removeClass(ACTIVE);
            }
        }
    });

    setInterval(function() {
        animateCarbon('next');
    }, 3000);
}

$(function() {
    !isFirst || productionOn();
});


const Production = Barba.BaseView.extend({
    namespace: 'production',

    onEnter() {
        //console.log('Новый контейнер готов и прикреплен к dom.')
        productionOn();
    },

    onEnterCompleted() {
        //console.log('Переход закончился.')
    },

    onLeave() {
        //console.log('Новый переход к новой странице только начался.')
        $html.off('keydown.barbaView');
    },

    onLeaveCompleted() {
        //console.log('Контейнер был удален из dom.')
    },
});

Production.init();



// WEBPACK FOOTER //
// ./production.js